import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  mainContainer: {
    width: '100%',
    maxWidth: '1300px',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inputContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: '70%',
  },
  inputNestedContainer: {
    width: '100%',
  },
  addButtonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  removeButtonContainer: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  removePaperButton: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  allowedReposTypePicker: {
    marginRight: theme.spacing(2),
    minWidth: '100px',
  },
  loadingProgress: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1,
  },
}));
